import { Component } from '@angular/core';
import { TransferBorrowerService } from '@services/transfer-borrower.service';
import { reportingIntervalDisplay } from '@components/main/spreading/spreading-column-header-display';
import {
  HUMAN_INPUT_REQUIRED_STATUS_LABEL,
  REVIEWED_STATUS_LABEL,
} from '@utils/constants';

const USER_INPUT_REQUIRED_DISPLAY_LABEL = 'User Input Required';


const STATUS_DISPLAY_OVERRIDES: Record<string, string> = {
  [HUMAN_INPUT_REQUIRED_STATUS_LABEL]: USER_INPUT_REQUIRED_DISPLAY_LABEL,
  [REVIEWED_STATUS_LABEL]:             USER_INPUT_REQUIRED_DISPLAY_LABEL,
};

@Component({
  selector: 'app-transfer-confirmation',
  templateUrl: './transfer-confirmation.component.html',
  styleUrls: ['./transfer-confirmation.component.scss'],
  standalone: false,
})
export class TransferConfirmationComponent {
  constructor(public service: TransferBorrowerService) {}
  humanize(code: string | null | undefined): string {
    if (!code) return '';
    return code
      .split('_')
      .map(w => w.length === 0 ? w : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(' ');
  }

  displayStatus(status: string | null | undefined): string {
    if (!status) return '';
    return STATUS_DISPLAY_OVERRIDES[status] ?? status;
  }
  displayReportingInterval(value: string | null | undefined): string {
    return reportingIntervalDisplay(value);
  }

  onAckChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.service.setAcknowledged(checked);
  }
}
